export const introduce = {
  text: `### 使用方法
  + • 关注黑色分隔线（数值1M）：指标在分隔线之上、说明市场足够健康，指标跌破分隔线，说明市场开始进入悲观时期。
  + • 绿色区域（150k-250k）：若指标跌入绿色区间，说明市场完全投降，此时往往是周期的底部区域。
  
  ### 指标原理
  + Dormancy：任何一天内每枚coin被销毁的平均天数
  + 市场健康程度 = 当前市值 ÷ 年化Dormancy值（USD）
  + 当「市场健康程度」保持高位时，市场可被视为健康，因为相对于市场的年化支出行为，价格仍然很高。
  + 每当「市场健康程度」下跌至最低点时，市场可以被视为完全投降，这就形成了一个良好的历史买入区。
  
  ### 创作者
  [Willy Woo 与 David Puell](https://woobull.com/experiments-on-cumulative-destruction/) 联合推出`,
  height: 1460,
};
